import SubscriptionsAPI from "./subscriptions"

export default {
  subscriptions: (jwt) => new SubscriptionsAPI(jwt)
}
